import {
  Wallet, PiggyBank, Baby, Home, GraduationCap,
  Building2, Car, LineChart, BookOpen, Sparkles, Calculator,
} from "lucide-react";

export const TOPICS = [
  {
    id: "paycheque",
    title: "Stop living paycheque to paycheque",
    blurb: "Build a buffer, take a breath, and feel money move with intention again.",
    icon: Wallet,
    span: "lg:col-span-2 lg:row-span-1",
    accent: "oxblood",
  },
  {
    id: "budgeting",
    title: "Budgeting that breathes",
    blurb: "A monthly rhythm for your money — flexible, kind, and impossible to mess up.",
    icon: Calculator,
    span: "lg:col-span-1",
    accent: "terracotta",
  },
  {
    id: "save-more",
    title: "Save more, gently",
    blurb: "Practical systems to set aside more — without giving up the things you love.",
    icon: PiggyBank,
    span: "lg:col-span-1",
    accent: "gold",
  },
  {
    id: "kids-future",
    title: "Money for the kids",
    blurb: "RESPs, savings habits and gifts that compound for the next generation.",
    icon: Baby,
    span: "lg:col-span-1",
    accent: "cognac",
  },
  {
    id: "moving-out",
    title: "Moving out for the first time",
    blurb: "Plan your first rent, deposits, and the cost of independence.",
    icon: Home,
    span: "lg:col-span-1",
    accent: "terracotta",
  },
  {
    id: "student-debt",
    title: "Student debt & loans",
    blurb: "Payoff strategies, refinancing and breathing room when it feels heavy.",
    icon: GraduationCap,
    span: "lg:col-span-1",
    accent: "oxblood",
  },
  {
    id: "buy-house",
    title: "Buy a house",
    blurb: "Down payment math, mortgage prep and timing your first home.",
    icon: Building2,
    span: "lg:col-span-2 lg:row-span-1",
    accent: "gold",
  },
  {
    id: "buy-car",
    title: "Buy a car (the smart way)",
    blurb: "Lease vs finance, true cost of ownership, and walking into a dealer prepared.",
    icon: Car,
    span: "lg:col-span-1",
    accent: "cognac",
  },
  {
    id: "investing",
    title: "Start investing",
    blurb: "TFSA, index funds, dollar-cost averaging — investing for everyday people.",
    icon: LineChart,
    span: "lg:col-span-1",
    accent: "terracotta",
  },
  {
    id: "financial-literacy",
    title: "Financial literacy & education",
    blurb: "Understand how money actually works — taxes, credit, compounding, and more.",
    icon: BookOpen,
    span: "lg:col-span-1",
    accent: "oxblood",
  },
  {
    id: "other",
    title: "Something else?",
    blurb: "Tell me your goal in your own words — every situation is welcome.",
    icon: Sparkles,
    span: "lg:col-span-1",
    accent: "gold",
    custom: true,
  },
];

export const findTopic = (id) => TOPICS.find((t) => t.id === id);
